import { Fragment } from 'react';
import DraggableSlider from './DraggbleSlider';
import DraggableScroll from './DraggbleScroll';

export interface FormProps
  extends React.DetailedHTMLProps<
    React.FormHTMLAttributes<HTMLFormElement>,
    HTMLFormElement
  > {}

export default Object.assign(
  ({ children, className = '', ...rest }: FormProps) => {
    return <Fragment />;
  },
  {
    Slider: DraggableSlider,
    Scroll: DraggableScroll,
  },
);
